export const constant = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    // baseUrl: "http://localhost:5001/", // Assuming we are using localhost. This should be in .env file but I want to show the problem
};
